import axios from "axios";
import { endpointAbonnement } from 'util/api';


/**
 * R�cup�ration de la liste des factures
 */
export const getFacturesRequest = async () => {
  const user = localStorage.user;
  const accessToken = user ? JSON.parse(user).id : '';

  const wsResponse = await axios.request({
    method: 'get',
    url: `${endpointAbonnement.GET_LIST_FACTURES}?access_token=${accessToken}`
  });

  return wsResponse;
}

/**
 * R�cup�ration de la liste des factures
 */
export const getFacturePdfRequest = async (payload) => {
  const user = localStorage.user;
  const accessToken = user ? JSON.parse(user).id : '';

  const { idAbonnement } = payload;

  const wsResponse = await axios.request({
    method: 'get',
    responseType: "blob",
    url: `${endpointAbonnement.GET_FACTURE_PDF}?access_token=${accessToken}`,
    params: {
      idAbonnement
    }
  });

  return wsResponse;
}